import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { StartClient } from '@tanstack/react-start/client';
import { initSentry } from '@/sentry';

// Sentry init: deferred so it doesn't compete with hydration. Same pattern
// the SPA entry used; just moved here since the entry is replaced.
type IdleScheduler = (cb: () => void, opts?: { timeout: number }) => void;
// oxlint-disable-next-line typescript/no-unsafe-type-assertion -- probing an optional global (requestIdleCallback) not in our lib target
const ric = (window as unknown as { requestIdleCallback?: IdleScheduler }).requestIdleCallback;
if (typeof ric === 'function') {
  ric(
    () => {
      initSentry();
    },
    { timeout: 2000 }
  );
} else {
  setTimeout(initSentry, 0);
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <StartClient />
    </StrictMode>
  );
});
